import WebLayout from "layout/webLayout.js";
import Contact from "./Contact";
import { useEffect } from "react";

const ContactPageSections = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <WebLayout>
      <Contact />
    </WebLayout>
  );
};

export default ContactPageSections;
